module.exports = __webpack_public_path__ + "c26eca6fd6e6e3b54f454c51875663b8.svg";